var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.showType == "A"
      ? _c("div", { staticClass: "btn-area--icon al_bottomcenter" }, [
          _c(
            "button",
            {
              staticClass: "btn icon",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.click("save")
                }
              }
            },
            [
              _c("i", { staticClass: "icon icon-download-02" }),
              _c("em", [_vm._v("저장")])
            ]
          ),
          _c(
            "button",
            {
              staticClass: "btn icon",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.click("share")
                }
              }
            },
            [
              _c("i", { staticClass: "icon icon-share" }),
              _c("em", [_vm._v("공유")])
            ]
          )
        ])
      : _vm._e(),
    _vm.showType == "B"
      ? _c("div", { staticClass: "btn-area--full fixed" }, [
          _c(
            "button",
            {
              staticClass: "btn md gray",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.click("save")
                }
              }
            },
            [
              _c("i", { staticClass: "icon icon-download-02" }),
              _vm._v(" " + _vm._s(/*저장*/ _vm.$t("MPAY-01-01-26-07")) + " ")
            ]
          ),
          _c(
            "button",
            {
              staticClass: "btn md gray",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.click("share")
                }
              }
            },
            [
              _c("i", { staticClass: "icon icon-share" }),
              _vm._v(" " + _vm._s(/*공유*/ _vm.$t("MPAY-05-01-01-31")) + " ")
            ]
          )
        ])
      : _vm._e(),
    _c(
      "div",
      { class: ["toasts", { hide: _vm.hasFlaggedItems }] },
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          { key: item.id, staticClass: "toast", attrs: { id: item.id } },
          [
            _c("div", { staticClass: "toast-body" }, [
              _c("i", { staticClass: "icon icon-check" }),
              _vm._v(" " + _vm._s(item.body) + " ")
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }